import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useRef } from 'react';
import c from 'classnames';
import isFunction from 'lodash/isFunction';
import InputFieldOutline from '../InputFieldOutline';
import s from './TextAreaInputField.scss';
/**
 * Our standard, plaintext `<textarea />` input.
 *
 * Allows indication of success or error via `validationResult`.
 */ const TextAreaInputField = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className , isRequired , validationResult , disabled  } = _param, rest = _object_without_properties(_param, [
        "className",
        "isRequired",
        "validationResult",
        "disabled"
    ]);
    const localTextAreaRef = useRef();
    return /*#__PURE__*/ React.createElement(InputFieldOutline, {
        className: c(s['root'], className),
        outlineStyle: disabled ? 'disabled' : validationResult,
        onClick: ()=>localTextAreaRef.current && localTextAreaRef.current.focus()
    }, /*#__PURE__*/ React.createElement("textarea", _extends({
        required: isRequired,
        className: s['input'],
        disabled: disabled,
        ref: (node)=>{
            if (isFunction(ref)) {
                ref(node);
            } else if (ref) {
                ref.current = node;
            }
            localTextAreaRef.current = node;
        }
    }, rest)));
});
TextAreaInputField.displayName = 'TextAreaInputField';
export default TextAreaInputField;
